import { Create, TextInput, SimpleForm } from "react-admin";

export default function ArtistCreate(props) {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name"></TextInput>
        <TextInput source="description"></TextInput>
      </SimpleForm>
    </Create>
  );
}
